import { render } from "./ManageAllItems.vue?vue&type=template&id=710d31a2"
import script from "./ManageAllItems.vue?vue&type=script&lang=js"
export * from "./ManageAllItems.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__